import { PayloadAction, createSlice } from "@reduxjs/toolkit"

export type Sort = {
    sortType: number,
    isAscending: boolean,
    tagFilters: number[],
    priorityFilters: number[]
}

export type SortMethod = {
    entities: Sort,
    isLoading: 'idle' | 'pending' | 'success' | 'error',
    error: string | null
}

export const initialStateSort: SortMethod = {
    entities: {
        sortType: 1,
        isAscending: true,
        tagFilters: [],
        priorityFilters: []
    },
    isLoading: 'idle',
    error: null
}


export const sortSlice = createSlice({
    name: "sort",
    initialState: initialStateSort,
    selectors: {
        selectSort: (state) => state.entities
    },
    reducers: {
        selected: (state, action: PayloadAction<{ data: Sort }>) => {
            state.entities = action.payload.data;
        },
        isAscendingReducerAdd: (state, action: PayloadAction<{ isAscending: boolean }>)  => {
            state.entities.isAscending = action.payload.isAscending;
        },
        tagsReducerAdd: (state, action: PayloadAction<{ tagId: number }>) => {
            state.entities.tagFilters.push(action.payload.tagId)
        },
        tagsReducerRemove: (state, action: PayloadAction<{ tagId: number}>) => {
            state.entities.tagFilters = state.entities.tagFilters.filter((id) => id !== action.payload.tagId)
        },
        tagsReducerReset: (state) => {
            state.entities.tagFilters = []
        },
        priorityReducerAdd: (state, action: PayloadAction<{ index: number }>) => {
            state.entities.priorityFilters.push(action.payload.index)
        },
        priorityReducerRemove: (state, action: PayloadAction<{ index: number }>) => {
            state.entities.priorityFilters = state.entities.priorityFilters.filter((id) => id !== action.payload.index)
        },
        priorityReducerReset: (state) => {
            state.entities.priorityFilters = []
        },
        sortTypeReducerUpdate: (state, action: PayloadAction<{ index: number }>) => {
            state.entities.sortType = action.payload.index
        }
        
} 
})
